import React from 'react'
import { StringParam, useQueryParams, withDefault } from 'use-query-params'

import { useDidMountEffect, useQueryList } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { ComplianceTable } from './complianceTable/ComplianceTable'

export function ComplianceContainer() {
  const { adminService } = useServices()
  const [queryParams, setQueryParams] = useQueryParams({
    direction: StringParam,
    sort: StringParam,
    startDate: StringParam,
    endDate: StringParam,
    status: withDefault(StringParam, 'pending'),
    query: StringParam
  })

  const [{ totalResults, isLoading, dataOrNull, errorMessageOrNull }, { query, nextPage, previousPage }] = useQueryList(
    adminService.getMonitoringSubscriptions,
    queryParams
  )

  useDidMountEffect(() => query(queryParams), [queryParams, query])

  return (
    <ComplianceTable
      subscriptions={dataOrNull}
      totalResults={dataOrNull?.length ? totalResults : 0}
      nextPage={nextPage}
      previousPage={previousPage}
      isLoading={isLoading}
      errorMessage={errorMessageOrNull}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
    />
  )
}
